var SharedObject = (function () {
    function SharedObject(name) {
        this._object_name = name;
        if (typeof (Storage) !== "undefined") {
            this.data = JSON.parse(localStorage.getItem(name));
        }
        if (this.data == null) {
            console.log("no shared object found");
            this.data = {};
        }
    }
    SharedObject.getLocal = function (name, localPath, secure) {
        return new SharedObject(name);
    };
    SharedObject.getRemote = function (name, remotePath, persistence, secure) {
        return new SharedObject(name);
    };
    SharedObject.prototype.flush = function (minDiscSapce) {
        if (minDiscSapce === void 0) { minDiscSapce = 0; }
        if (typeof (Storage) !== "undefined") {
            localStorage.setItem(this._object_name, JSON.stringify(this.data));
        }
        else {
            console.log("no local storage available");
        }
    };
    SharedObject.prototype.clear = function () {
    };
    SharedObject.prototype.close = function () {
    };
    SharedObject.prototype.connect = function (myConnection, params) {
        if (params === void 0) { params = null; }
    };
    SharedObject.prototype.setDirty = function (propertyname) {
    };
    SharedObject.prototype.setProperty = function (propertyname, value) {
    };
    SharedObject.prototype.send = function (args) {
    };
    return SharedObject;
}());
export { SharedObject };
